export default {"src":"/_next/static/media/profileLogin.24af6cdf.svg","height":18,"width":18};